export default [
  {
    path: '/school-contacts',
    title: 'schoolContact',
    icon: 'fas fa-phone-volume',
    permission: 'view-school-contacts'
  },
  {
    path: '/calendars',
    title: 'calendar',
    icon: 'fas fa-calendar',
    permission: 'view-calendars'
  },
  {
    path: '/holidays',
    title: 'holiday',
    icon: 'fas fa-plane',
    permission: 'view-holidays'
  },
  {
    path: '/events',
    title: 'eventActivity',
    icon: 'fas fa-chart-line',
    permission: 'view-events'
  },
  {
    path: '/class-attendances',
    title: 'classAttendance',
    icon: 'far fa-user',
    permission: 'view-class-attendances'
  },
  {
    path: '/exam-schedules',
    title: 'examSchedule',
    icon: 'fas fa-clipboard-list',
    permission: 'view-exam-schedules'
  },
  {
    path: '/homeworks',
    title: 'homework',
    icon: 'fas fa-book',
    permission: 'view-homeworks'
  },
  {
    path: '/student-galleries',
    title: 'studentGallery',
    icon: 'fas fa-images',
    permission: 'view-student-galleries'
  },
  {
    path: '/disciplinary-records',
    title: 'disciplinary',
    icon: 'fas fa-calendar',
    permission: 'view-disciplinary-records'
  },
  {
    path: '/notification-histories',
    title: 'notificationHistory',
    icon: 'fas fa-history',
    permission: 'view-notification-histories'
  },
  // {
  //   icon: 'fas fa-align-center',
  //   path: '/student-scoring-component-entries',
  //   title: 'scoreComponentEntry',
  //   permission: 'view-student-scoring-component-entries'
  // },
  {
    icon: 'fas fa-user-graduate',
    path: '/student-scoring-entries',
    title: 'scoreEntry',
    permission: 'view-student-scoring-entries'
  },
  {
    icon: 'fas fa-file',
    path: '/report/report-cards',
    title: 'reportCards',
    permission: 'view-report-cards'
  },
  {
    icon: 'fa fa-comment',
    path: '/chats',
    title: 'chat',
    permission: 'view-chats'
  },
  {
    title: 'thesis',
    icon: 'fa fa-folder',
    children: [
      {
        path: '/thesis-topics',
        title: 'thesisTopic',
        permission: 'view-thesis-topics'
      },
      {
        path: '/thesis',
        title: 'thesisRegistration',
        permission: 'view-thesis-registrations'
      }
    ]
  },
  {
    title: 'report',
    icon: 'fas fa-file',
    children: [
      {
        path: '/report/student-lists',
        title: 'studentList',
        permission: 'view-student-lists'
      },
      {
        path: '/report/student-enrollments',
        title: 'studentEnrollment',
        permission: 'view-student-enrollment'
      },
      {
        path: '/report/final-results',
        title: 'finalResult',
        permission: 'view-final-results'
      },
      {
        path: '/report/score-lists',
        title: 'scoreList',
        permission: 'view-score-lists'
      }
    ]
  }
]
